import * as ActionTypes from './action-types';

export function canvasReset() {
  return {
    type: ActionTypes.CANVAS_RESET,
  };
}

export function canvasStart() {
  return {
    type: ActionTypes.CANVAS_START,
  };
}

export function canvasStop() {
  return {
    type: ActionTypes.CANVAS_STOP,
  };
}
